import React, { Component } from 'react';
import { WithStyles, Select, Input, MenuItem, ListItemText, Chip } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { MyPATTextField, MyPATTextArea, MyPATSelect } from '../../../common';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { connect } from 'react-redux';
import advanceSettingService from "../../services/advancedSettingService"
import { showMsg } from '../../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { styles } from '../../styling/component/AdvanceSetting/TagsContent'
import _ from 'lodash';
import cx from 'classnames';
import { Tag } from '../../modals/CourseBasicInfo';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},	
	},
};

interface TagsContentProps extends WithStyles<typeof styles> {
	showMsg: (msg: string, vari: string) => void,
	cardDetails: any
}

interface TagsContentState {
	mandatoryTags: Tag[],
	optionalTags: Tag[],
	showMoreFlag: Boolean,
	setTags: Boolean,
}

class TagsContent extends Component<TagsContentProps, TagsContentState> {
	constructor(props: TagsContentProps) {
		super(props);

		this.state = {
			mandatoryTags: [],
			optionalTags: [],
			showMoreFlag: true,
			setTags: false,
		}

		this.getMandatoryTags = this.getMandatoryTags.bind(this)
		this.getOptionalTags = this.getOptionalTags.bind(this)
		this.handleChangeRadio = this.handleChangeRadio.bind(this)
		this.showMoreTags = this.showMoreTags.bind(this)
	}
	componentDidUpdate() {
		let { mandatoryTags, setTags } = this.state;
		if (!_.isEmpty(mandatoryTags)) {
			const cardDetails: any[] = _.get(this.props, 'cardDetails.setting.tags', []);
			let isTrue = 0;
			if (!_.isEmpty(cardDetails)) {
				mandatoryTags.map((mt: any, mi: number) => {
					const tag = _.find(cardDetails, ['_id', mt._id]);
					const mtValue = _.get(mt, 'content.value', '');
					mtValue || mtValue == '' ? isTrue++ : null;

					if (!_.isEmpty(tag)) {
						mt['content']['value'] = tag.value;
					}
				});

				if (!setTags) {
					this.setState({ setTags: true });
				}
				if (_.isEqual(isTrue, 0)) {
					this.setState({ mandatoryTags });
				}
			}
		}
	}
	componentWillMount() {
		this.getMandatoryTags();
	}

	getMandatoryTags() {
		let self = this
		advanceSettingService.getMandatoryTags().then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData.length > 0) {
				self.setState({
					mandatoryTags: responseData
				})
			}
		});

	}

	getOptionalTags() {
		const tags = this.props.cardDetails.setting.tags
		let self = this
		advanceSettingService.getOptionalTags().then((responseData: any) => {
			self.setState({
				showMoreFlag: false
			})

			if (!_.isEmpty(responseData) && responseData.length > 0) {
				self.setState({
					optionalTags: responseData,
					showMoreFlag: false
				})
			} else {
				self.props.showMsg("No optional tags found.", 'success');
			}

			responseData.map((ot: any, i: number) => {
				tags.map((t: any, i: number) => {
					if (ot._id == t._id) {
						ot.content['value'] = t.value
					}
				})
			})

			this.setState({
				optionalTags: responseData
			})

		});
	}

	handleChangeMultiple = (event: any) => {
		const { options } = event.target;
		const value : any = [];
		for (let i = 0, l = options.length; i < l; i += 1) {
			if (options[i].selected) {
				value.push(options[i].value);
			}
		}
	};

	handleChangeRadio(getID: string, value: string) {
		let getElement = (document.getElementById(`hdn_${getID}`) as HTMLInputElement);
		getElement.value = value
		this.forceUpdate()
	}
	addToChecked(event: any) {

		var elementReference = event.currentTarget.parentElement.parentElement
		var getName = elementReference.getAttribute("data-name")
		var getID = elementReference.getAttribute("data-id")

		let inputValue = "";
		let valueArr: string[] = []

		let getElement = (document.getElementById(`hdn_${getID}`) as HTMLInputElement);
		inputValue = (getElement.value) || "";
		if (inputValue != "") {
			valueArr = (inputValue).split(",")
		}

		if (valueArr.indexOf(getName) == -1) {
			valueArr.push(getName)
		} else {
			valueArr = valueArr.filter(function (v) {
				return v !== getName
			})
		}

		getElement.value = valueArr.join(",")
		this.forceUpdate()
	}

	handleChange() {
		alert("SD")
	}

	getMandatoryFieldLabel(type : string,fieldName : string){
		if(type=== 'mandatory'){
		return fieldName+'*';
		}
		return fieldName;
	}

	tagsBasedOnType(value: any, index: number, type: string) {
		let { content } = value;

		content.value = _.get(content, 'value', "");

		// content.value = content.value ? content.value : "";
		let { classes } = this.props;
		var self = this;
		let _html: any = [];
		switch (content.type) {
			case "listpicker":
				_html.push(
					<Grid container
						xs={4}
						spacing={16}
						alignItems="center"
						direction="row"
						justify="flex-start"
						max-width= "33%;"
						flex-basis= "100%"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.widthContent)}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								data-type={content.type}
								className={cx(classes.widthContent)}
								id={`${type}${index}`}>
								<MyPATSelect
									defaultValue={content.value}
									multiple
									fullWidthControl
									className={cx(classes.widthContent)}
									id={`${content.type}${value._id}`}
									inputProps={{
										autoComplete: "off"
									}}
								>
									<option value="">Select</option>
									{
										content.data.map(function (v: string) {
											return <option value={v}>
												{v}
											</option>
										})
									}
								</MyPATSelect>
							</div>
						</Grid>
					</Grid>
				)
				break;
			case "datepicker":
				_html.push(
					<Grid container xs={4}
						spacing={16}
						alignItems="center"
						direction="row"
						justify="flex-start"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.dynamicInputWidth)} >
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								data-type={content.type}
								className={cx(classes.widthContent)}
								id={`${type}${index}`}>
								<MyPATTextField
									defaultValue={content.value}
									type="datetime-local"
									variant="outlined"
									className={cx(classes.widthContent)}
									id={`${content.type}${value._id}`}
									fullWidth margin="dense"
									InputLabelProps={{
										shrink: true,
										minLength: 3
									}}
								/>
							</div>
						</Grid>
					</Grid>
				)
				break;

			case "checkboxOptions":
				let checkboxValue = "";
				let checkboxArr: string[] = []

				if (content.value) {
					let selectedCheckBoxes = content.value.split(',')
					if (selectedCheckBoxes) {
						selectedCheckBoxes.forEach((checked: any) => {
							checkboxArr.push(checked)
						})
					}
				}
				try {
					checkboxValue = ((document.getElementById(`hdn_${value._id}`) as HTMLInputElement).value) || "";

					if (checkboxValue != "") {
						checkboxArr = (checkboxValue).split(",")
					}
				} catch (e) {

				}

				_html.push(
					<Grid container
						xs={4}
						spacing={16}
						alignItems="center"
						direction="row"
						justify="flex-start"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.widthContent)}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								id={`${type}${index}`}
								className={cx(classes.widthContent)}
								data-type={content.type}>
								<input type="hidden" id={`hdn_${value._id}`} />
								{
									content.data.map(function (v: string, i: number) {
										return <FormControlLabel
											key={i}
											label={v}
											control={
												<Checkbox
													color="primary"
													onChange={self.addToChecked.bind(self)}
													data-name={v}
													checked={checkboxArr.indexOf(v) > -1}
													data-id={`${value._id}`}
													className={`${value._id}`}

												/>
											}
										/>
									})
								}
							</div>
						</Grid>
					</Grid>
				)
				break;

			case "radioOptions":
				let radioValue = "";
				try {
					radioValue = ((document.getElementById(`hdn_${value._id}`) as HTMLInputElement).value) || "";
				} catch (e) {
					radioValue = "";
				}

				if (radioValue == "") {
					radioValue = content.value;
				}


				_html.push(
					<Grid container
						spacing={16}
						xs={4}
						alignItems="center"
						direction="row"
						justify="flex-start"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.widthContent)}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								id={`${type}${index}`}
								className={cx(classes.widthContent)}
								data-type={content.type}>
								<input type="hidden" id={`hdn_${value._id}`} />
								{content.data.map(function (v: string, i: number) {
									return <FormControlLabel value={v} control={<Radio
										checked={radioValue === v}
										aria-label="gender"
										onChange={() => self.handleChangeRadio(value._id, v)}
										value="b"
										name="radio-button-demo"
									/>} label={v} />
								})
								}
							</div>
						</Grid>
					</Grid>
				)
				break;

			case "listpickerMultiselect":
				let inputValue: any = "";
				let valueArr: string[] = []
				if (content.value) {
					valueArr.push(content.value);
				}
				try {
					inputValue = ((document.getElementById(`hdn_${value._id}`) as HTMLInputElement).value) || "";
					if (inputValue != "") {
						valueArr = (inputValue).split(",")
					}
				} catch (e) {
				}

				_html.push(
					<Grid container
						spacing={16}
						xs={4}
						alignItems="center"
						direction="row"
						justify="flex-start"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.widthContent)}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<input type="hidden" id={`hdn_${value._id}`} />
							<div data-id={value._id}
								data-name={value.name}
								id={`${type}${index}`}
								className={cx(classes.widthContent)}
								data-type={content.type}>
								<Select
									style={{ width: "420px !important" }}
									multiple
									className={cx(classes.widthContent, classes.defaultSelect)}
									value={valueArr}
									disableUnderline={true}
									input={<Input id="select-multiple-chip" />}
									renderValue={(selected: any) => (
										<div className={classes.chips}>
											{selected.map((value: any, index: number) => (
												<Chip key={`${value} ${index}`} label={value} />
											))}
										</div>
									)}
									MenuProps={MenuProps}
								>
									{content.data.map((v: string) => (
										<MenuItem style={{ textTransform: 'capitalize' }}>
											<Checkbox onChange={this.addToChecked.bind(this)}
												data-name={v}
												checked={valueArr.indexOf(v) > -1}
												data-id={`${value._id}`}>
											</Checkbox>
											<ListItemText primary={v} />
										</MenuItem>
									))}
								</Select>
							</div>

						</Grid>
					</Grid>)
				break;
			case "text":
				_html.push(
					<Grid container
						spacing={16}
						xs={3}
						alignItems="center"
						direction="row"
						justify="flex-start"
						className={cx(classes.marginBottom10)}>
						<Grid item className={cx(classes.dynamicInputWidth)}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								id={`${type}${index}`}
								className={cx(classes.widthContent)}
								data-type={content.type}>
								<MyPATTextField
									defaultValue={content.value}
									type="text"
									variant="outlined"
									id={`${content.type}${value._id}`}
									fullWidth margin="dense"
									className={cx(classes.widthContent)}
									InputLabelProps={{
										shrink: true,
										minLength: 3
									}}
								/>
							</div>
						</Grid>
					</Grid>
				)
				break;

			case "textLonginput":
				_html.push(
					<Grid container
						spacing={16}
						alignItems="center"
						direction="row"
						xs={4}
						justify="flex-start"
						className={cx(classes.widthContent, classes.marginBottom10)}
					>
						<Grid item style={{ width: "95%" }}>
							<Typography className={cx(classes.marginBottom10)} variant="body2">{this.getMandatoryFieldLabel(type,value.name)}</Typography>
							<div data-id={value._id}
								data-name={value.name}
								id={`${type}${index}`}
								className={cx(classes.widthContent)}
								data-type={content.type}>
								<MyPATTextArea
									defaultValue={content.value}
									inputId="milestoneObjective"
									id={`${content.type}${value._id}`}
									name="milestoneObjective"
									rows="1"
									multiline
									fullWidthControl
								/>
							</div>
						</Grid>
					</Grid>
				)
				break;
			default:
		}

		return _html

	}
	showMoreTags = () => this.setState({ showMoreFlag: true })
	render() {
		let { classes, cardDetails } = this.props;
		let self = this;
		const { mandatoryTags, optionalTags, showMoreFlag, setTags } = this.state;
		const test = JSON.parse(JSON.stringify(mandatoryTags));
		var courseID = (window.location.href)
		courseID = courseID.substring(courseID.lastIndexOf("/") + 1, courseID.length)

		let mandatoryListHTML : any = []
		mandatoryListHTML = mandatoryTags.map(function (v: any, i: number) {
			return self.tagsBasedOnType(v, i, "mandatory")
		})

		let optionalListHTML = optionalTags.map(function (v, i) {
			return self.tagsBasedOnType(v, i, "optional")
		})

		return (
			<>
				<Grid container xs={12} className={cx(classes.wrapperMain, classes.borderDefault, classes.marginTop10)} >
					<Typography variant="h6" style={{ padding: "10px", width: "100%" }}>
						Add Tags *
							</Typography>
					{setTags && mandatoryListHTML}

					{setTags || mandatoryListHTML}


					{
						showMoreFlag ?
							<Grid container
								alignItems="center"
								direction="row"
								justify="flex-start"
								onClick={self.getOptionalTags}
								className={cx(classes.marginTop10, classes.link)}>
								+ Show More
								</Grid>
							:

							<Grid container
								alignItems="center"
								direction="row"
								justify="flex-start"
							>
							</Grid>
					}
					{
						!showMoreFlag && optionalListHTML
					}
					{
						!showMoreFlag ?
							<Grid container
								alignItems="center"
								direction="row"
								justify="flex-start"
								onClick={this.showMoreTags}
								className={cx(classes.marginTop10, classes.link)}>
								- Show Less
								</Grid>
							:
							""
					}
				</Grid>
			</>
		)
	}
}

// @ts-ignore
const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
	},
	dispatch
);


// @ts-ignore
export default connect(null, mapDispatchToProps)(withStyles(styles)(TagsContent));
